export default function StarSVG({ rank, fill }) {
  return (
    <div className="flex flex-row gap-[3px]">
      {Array.from({ length: rank }, (item) => {
        return (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
            >
              <defs>
                <filter id="glow">
                  <feGaussianBlur stdDeviation="0" result="coloredBlur" />
                  <feMerge>
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="SourceGraphic" />
                  </feMerge>
                </filter>
                <filter id="glow2">
                  <feGaussianBlur stdDeviation="0" result="coloredBlur" />
                  <feMerge>
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="SourceGraphic" />
                  </feMerge>
                </filter>
                <filter id="glow3">
                  <feGaussianBlur stdDeviation="0" result="coloredBlur" />
                  <feMerge>
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="SourceGraphic" />
                  </feMerge>
                </filter>
              </defs>

              <polygon
                points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
                fill={fill}
                filter={
                  rank === 5
                    ? "url(#glow)"
                    : rank === 4
                    ? "url(#glow2)"
                    : "url(#glow3)"
                }
              />
            </svg>
          </>
        );
      })}
    </div>
  );
}
